import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaDocumentos', NominasNominaDocumentos)

function NominasNominaDocumentos($http) {
  this.get = function (id_empresa, id_nomina) {
    return $http.get('/api/nominas/nomina/documentos', {
      params: {id_empresa: id_empresa, id_nomina: id_nomina},
      schema: this.schema,
    })
  }.bind(this)

  this.schema = {
    cfdis: {
      contenido: {
        status_timbrado: 'boolean',
      },
    },
    comprobantedeposito: 'boolean',
    cotizacion: 'boolean',
    estados_de_cuenta: 'boolean',
    tabulado: {
      incluir_resumen: 'boolean',
      incluir_bancos: 'boolean',
      omitir_conceptos_cero: 'boolean',
      incluir_departamentos: 'boolean',
      separar_impuesto_estatal: 'boolean',
      separar_salas: 'boolean',
      pueblo_bonito: 'boolean',
    },
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos.js